

















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import SubscriptionPlan from '@/models/payment/SubscriptionPlan';

@Component
export default class PaymentPlanComponent extends Vue
{
    @Prop(SubscriptionPlan) readonly plan!: SubscriptionPlan;
    get renderedMonthlyPricePerUser()
    {
        const numbersInDescription = this.plan.description.match(/\d+/g);
        const userCount =
            (numbersInDescription && numbersInDescription.length > 1)
                ? Number.parseInt(numbersInDescription[numbersInDescription.length - 1])
                : 1;
        return (Math.ceil(this.price / this.plan.billingCycle / userCount * 100) / 100).toFixed(2);
    }

    get renderedMonthlyPrice()
    {
        return (Math.ceil(this.price / this.plan.billingCycle * 100) / 100).toFixed(2);
    }

    get renderedPrice()
    {
        return (Math.ceil(this.price * 100) / 100).toFixed(2);
    }

    get price()
    {
        return ((this.shouldGetEduDiscount) ? (this.plan.price * 0.75) : (this.plan.price));
    }

    get displayName()
    {
        return this.plan.name.replace(/ - /g, '\n');
    }

    get shouldGetEduDiscount()
    {
        return this.user.eduEligibilityOverride || this.user.email.endsWith('.edu');
    }
}
